/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_cartesianpoint.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input value to a `cartesian_point` value.
 * A string will only be successfully converted if it respects the
 * WKT Point format.
 *
 * @example
 * ROW wkt = ["POINT(4297.11 -1475.53)", "POINT(7580.93 2272.77)"]
 * | MV_EXPAND wkt
 * | EVAL pt = TO_CARTESIANPOINT(wkt)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_cartesianpoint',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_point',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_point',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_point',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
